<template>
  <b-dropdown right :text="summaryText" variant="outline-dark" @hide="saveChanges" ref="dropdown" :disabled="disabled">
    <b-dropdown-form style="min-width:320px" v-on:submit.prevent.stop="saveAndClose">
      <b-alert :show="infoText != null">{{infoText}}</b-alert>
      <b-form-group :label="`${itemTypeName}:`">
        <b-form-checkbox-group stacked v-model="selectedItems" name="items">
          <b-form-checkbox v-for="(item, itemIndex) in allItems" :key="itemIndex" :value="item">{{item.name}}</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-alert :show="!isValid" variant="danger">{{errorMessage}}</b-alert>
      <p class="text-right mb-0">
        <b-button size="sm" variant="secondary" @click="resetAndClose">Cancel</b-button>
        <b-button size="sm" variant="primary" @click="saveAndClose">Update</b-button>
      </p>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ListFilter',
  props: ['filter', 'allItems', 'itemTypeName', 'disabled', 'infoText'],
  data () {
    return {
      selectedItems: this.allItems.filter((i) => { return this.filter.ids.find((id) => { return parseInt(id) === i.id }) != null }),
      isValid: true,
      errorMessage: ''
    }
  },
  components: {},
  computed: {
    summaryText () {
      if (this.filter.ids.length === 0) {
        return 'None'
      } else if (this.filter.ids.length === 1) {
        return this.filterItems[0].name
      } else {
        return `${this.filter.ids.length} selected`
      }
    },
    filterItems () {
      return this.allItems.filter((i) => { return this.filter.ids.find((id) => { return parseInt(id) === i.id }) != null })
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    validate () {
      this.isValid = true
      if (this.selectedItems.length === 0) {
        this.isValid = false
        this.errorMessage = `Please select at least one ${this.itemTypeName}`
      }
      return this.isValid
    },
    resetAndClose (evt) {
      this.selectedItems = _.clone(this.filterItems)
      this.isValid = true
      this.errorMessage = ''
      this.$refs.dropdown.hide()
    },
    saveChanges (evt) {
      if (this.validate()) {
        this.commit()
      } else {
        evt.preventDefault()
      }
    },
    saveAndClose () {
      if (this.validate()) {
        this.$refs.dropdown.hide()
      }
    },
    commit () {
      this.filter.ids = this.selectedItems.map((i) => { return i.id })
      this.$emit('input', this.filter)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/ListFilter.vue